module.exports = __webpack_public_path__ + "media/images/emblems/Montricher-coat_of_arms-f570884bfb7054e20c12cbbeb34c4d7b.svg";